import * as React from 'react';
import history from '../../../../history';

type BillingButtonProps = {
    title: string;
    to: string;
    onClick: () => void;
    className: string;
    mode: 'blue' | 'light-blue-with-border';
}

function BillingButton({ title, to, onClick, className, mode = 'light-blue-with-border' }: BillingButtonProps) {

    const handleOnClick = () => {
        if (onClick) {
            onClick();
        } else {
            history.push(to);
        }
    };

    return <div onClick={handleOnClick} className={`billing-button action-btn ${mode}  ${className}`}>
        {title}
    </div>;
}

export default BillingButton;
